<input *ngIf="showSearch"
       type="text"
       class="form-control icon-search tree-view-search"
       autocomplete="off"
       placeholder="Search Fields..."
       ng-model-options="{ debounce: 200 }"
       [(ngModel)]="filterPattern"
       data-test="filter-search" />

 <ng-container *ngFor="let node of nodes | filterSearch:filterPattern; trackBy: trackById">
    <mode-tree
      [node]="node"
      [template]="nodeTemplate"
      [getId]="getId"
      [getChildren]="getChildrenIfOpen"
    ></mode-tree>
 </ng-container>

<ng-template #nodeTemplate
  let-node
  let-level="level"
>
  <div class="tree-view-node"
    [class.tree-view-node--selected]="selectedId === getId(node)"
    [class.tree-view-node--disabled]="node.inUse || node.isAggregate"
    [style.margin-left.px]="level * indentation"
    (click)="onSelect(node)"
  >
    <capra-icon *ngIf="getChildren(node)?.length" class="folder-toggle"
      [class.folder-toggle--open]="isOpen(node)" icon="icon-chevron"></capra-icon>
    <ng-container
      [ngTemplateOutlet]="template"
      [ngTemplateOutletContext]="{ $implicit: node }"
    ></ng-container>
  </div>
</ng-template>
